import script from "./BatteryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BatteryIcon.vue?vue&type=script&setup=true&lang=js"

import "./BatteryIcon.vue?vue&type=style&index=0&id=765e22ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_861e304fb8ba8ab2c2aa266f6b3984bf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765e22ac"]])

export default __exports__